import React, { useEffect, useState } from 'react'
import LoginCard from './LoginCard'
import { login } from '../services/auth.service'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { LOGIN_SLIDES, LOGIN_SLIDE_INTERVAL } from '../constants/loginSlides'

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [slide, setSlide] = useState(0)

  // Panel kanan cuma dirender di layar besar, tapi timer-nya tetap ringan
  // jadi tidak perlu dimatikan khusus untuk mobile.
  useEffect(() => {
    if (LOGIN_SLIDES.length < 2) {
      return undefined
    }
    const timer = setInterval(
      () => setSlide((current) => (current + 1) % LOGIN_SLIDES.length),
      LOGIN_SLIDE_INTERVAL,
    )
    return () => clearInterval(timer)
  }, [])

  const handleLogin = async () => {
    if (isLoading) {
      return
    }
    if (!username || !password) {
      toast.error('Username dan kata sandi wajib diisi.')
      return
    }
    try {
      setIsLoading(true)
      await login(username, password)
      onLogin()
    } catch (error) {
      console.error('Error during login:', error)
      if (error instanceof AxiosError) {
        toast.error(
          error.response?.data?.error?.message ??
            'Gagal masuk. Periksa kembali username dan kata sandi Anda.',
        )
        return
      }
      toast.error('Gagal masuk. Periksa kembali username dan kata sandi Anda.')
    } finally {
      setIsLoading(false)
    }
  }

  const active = LOGIN_SLIDES[slide] ?? LOGIN_SLIDES[0]

  return (
    <div className="min-h-screen bg-white lg:p-4">
      <div className="flex min-h-screen lg:min-h-[calc(100vh-2rem)] gap-4">
        <div className="flex-1 flex items-center justify-center px-6 py-10">
          <LoginCard
            username={username}
            setUsername={setUsername}
            password={password}
            setPassword={setPassword}
            handleLogin={handleLogin}
            isLoading={isLoading}
          />
        </div>

        {/* Panel gambar disembunyikan di layar kecil supaya form tetap jadi
            fokus utama dan halaman tidak berat di jaringan seluler. */}
        <div className="hidden lg:block relative flex-1 rounded-2xl overflow-hidden bg-[#191a1a]">
          {active?.image && (
            <img
              src={active.image}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

          <div className="absolute inset-x-0 bottom-0 p-10 text-white">
            {LOGIN_SLIDES.length > 1 && (
              <div className="flex gap-2 mb-6">
                {LOGIN_SLIDES.map((item, index) => (
                  <button
                    key={item.title}
                    type="button"
                    onClick={() => setSlide(index)}
                    aria-label={`Tampilkan slide ${index + 1}`}
                    className={`h-1 w-10 rounded-full transition-colors ${
                      index === slide ? 'bg-white' : 'bg-white/40'
                    }`}
                  />
                ))}
              </div>
            )}
            <h2 className="text-3xl font-bold">{active?.title}</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/80">
              {active?.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
